// extracted by mini-css-extract-plugin
export default {"HomeView":"HomeView_HomeView__Vfd1G"};